import * as React from "react";
import "@aurodesignsystem/auro-button";
import "@alaskaairux/auro-icon";
import "./Titlebar.scss";

export interface CreateTitlebarProps {
    status: string;
    isSubmitDisabled: boolean;
    handleClose: () => void;
    handleAddSubmit: () => void;
    handleDone?: () => void;
}
interface TitleBarProps {
  createventdata: CreateTitlebarProps
  title: string;
  submitButtonText?: string;
}

export function CreateTitleBar({ createventdata, title, submitButtonText = "Create" }: TitleBarProps) {
    const [createdata, setCreateData] = React.useState({
        status: "",
        isSubmitDisabled: true,
        handleClose: () => {},
        SubmitData: () => {},
        handleDoneClick: () => {}
    });

    React.useEffect(() => {
        if (createventdata != null) {
            setCreateData({
                status: createventdata.status,
                isSubmitDisabled: createventdata.isSubmitDisabled,
                handleClose: createventdata.handleClose,
                SubmitData: createventdata.handleAddSubmit,
                handleDoneClick: createventdata.handleDone || (() => {})
            });
        }
    }, [createventdata]);
  
    return (
        <div className="titlebar titlebar_create">
            <div className="titlebar-container titlebar_creates">
                <span className="lblotsevent lblcreatesize">
                    {title}
                </span>
                <div className={createdata.status === "" ? "buttons-section" : "buttons-section button_alert"}>
                    {createdata.status === "loading" && 
                        <auro-button class="loading-title-button" loading variant="primary" data-testid="loading-button" />}
                    {createdata.status === "done" && 
                        <auro-button class="done-button" onClick={createdata.handleDoneClick} variant="primary" data-testid="done-button">
                            <span className="btnlabel-white modal-btn">Done</span>
                        </auro-button>}
                    {createdata.status === "success" && <button className="success-button"><h2 className="alert-text" data-testid="success-button">Event created Successfully!</h2></button>}
                    {createdata.status === "error" && <button className="error-button" data-testid="alert-button"><h2 className="alert-text">Event creation failed. Try again!</h2></button>}
                    {createdata.status === "" &&
                        <div className="form-action">
                            <div className="form-button">
                                <auro-button variant="secondary" fluid onClick={createdata.handleClose}>
                                    <span className="btnlabel-blue modal-btn">Cancel</span>
                                </auro-button>
                            </div>
                            <div className="form-button">
                                <auro-button 
                                    variant="primary" 
                                    fluid 
                                    class={createdata.isSubmitDisabled ? "disabled" : ""} 
                                    onClick={createdata.SubmitData}
                                    data-testid="submit-button"
                                >
                                    <span className="btnlabel-white modal-btn">{submitButtonText}</span>
                                </auro-button>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
}